module.exports = require("@player1os/base-error");


//////////////////
// WEBPACK FOOTER
// external "@player1os/base-error"
// module id = 0
// module chunks = 0